import { getAcronymStateById } from '@ferreri/prever-component-lib';

export const formatAddress = (address: any) => {
  return `${address?.street}, ${address?.street_number} ${
    address?.complement || ''
  } - ${address?.city?.name}, ${
    getAcronymStateById(extractStateId(address?.city?.code)) || ''
  }, ${address?.zip_code}`;
};

const extractStateId = (cityCode: string) => {
  return cityCode?.substring(0, 2);
};
